import { ApplicationRoutes } from '../../../app-routes-names'

export const ReportsRoutes = {
  calls: 'calls',
  sales: 'sales',
  tires: 'tires',
  upsell: 'upsell',
  upsellSummary: 'upsell-summary',
  upsellList: 'upsell-list',
  compare: 'compare',
  movingAverage: 'moving-average',
  dailyAverage: 'daily-average',
  compareObjectives: 'compare-objectives',
  compareObjectivesRegional: 'compare-objectives-regional',
  adjustedGP: 'adjusted-gross-profit',
  googleReviews: 'google-reviews',
  googleReviewsTrends: 'google-reviews/trends',
  googleReviewsDetail: 'google-reviews/:locationId',
  oilChange: 'oil-change'
}

const { reports } = ApplicationRoutes

export const ReportsPaths = {
  calls: `/${reports}/${ReportsRoutes.calls}`,
  sales: `/${reports}/${ReportsRoutes.sales}`,
  tires: `/${reports}/${ReportsRoutes.tires}`,
  upsell: `/${reports}/${ReportsRoutes.upsell}`,
  upsellSummary: `/${reports}/${ReportsRoutes.upsellSummary}`,
  upsellList: `/${reports}/${ReportsRoutes.upsellList}`,
  compare: `/${reports}/${ReportsRoutes.compare}`,
  movingAverage: `/${reports}/${ReportsRoutes.movingAverage}`,
  dailyAverage: `/${reports}/${ReportsRoutes.dailyAverage}`,
  compareObjectives: `/${reports}/${ReportsRoutes.compareObjectives}`,
  compareObjectivesRegional: `/${reports}/${ReportsRoutes.compareObjectivesRegional}`,
  adjustedGP: `/${reports}/${ReportsRoutes.adjustedGP}`,
  googleReviews: `/${reports}/${ReportsRoutes.googleReviews}`,
  googleReviewsTrends: `/${reports}/${ReportsRoutes.googleReviewsTrends}`,
  googleReviewsDetail: (locationId: string) => `/${reports}/google-reviews/${locationId}`,
  oilChange: `/${reports}/${ReportsRoutes.oilChange}`
}
